import { Oval } from "react-loader-spinner";

const Loader = () => {
  return (
    <div className="loader-spinner">
      <Oval
        height={80}
        width={80}
        color="#3b82f6"
        ariaLabel="loading"
        secondaryColor="#475569"
        strokeWidth={4}
      />
    </div>
  );
};

export default Loader;
